import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";

import HeaderTwo from "../../components/HeaderTwo";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import FooterTwo from "../../components/FooterTwo";
import { Styles } from "./styles/instructor.js";
import TabBox from "../../components/about/TabBox.js";
import TestimonialSlider from "../../components/about/TestimonialSlider.js";
import FaqEvent from '../../components/FaqEvent';

class Mission extends Component {
  render() {
    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper instructor-details-page">
          {/* Header 2 */}
          <HeaderTwo />

          {/* Breadcroumb */}
          <BreadcrumbBox title="Mission & Vision" />

          {/* Instructor Details Area */}
          <section className="instructor-details-area">
            <Container>
              <Row>
                <Col md="4">
                  <div className="instructor-img">
                    <img
                      src={process.env.PUBLIC_URL + `/assets/images/team-7.jpg`}
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </Col>
                <Col md="8">
                  <div className="instructor-content">
                  <h4>Our Mission</h4>
                    <span>Providing Quality Education for All</span>
                    <p>
                      Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                      Veritatis tenetur accusantium laudantium! Vitae libero
                      voluptatum velit earum corrupti officia quo, magnam
                      mollitia nam provident tempora. Ipsum quaerat tempora odit
                      maxime. Lorem ipsum, dolor sit amet consectetur
                      adipisicing elit. Optio, molestiae. Quae illum non sit. In
                      sapiente, reiciendis sunt aperiam repellendus quibusdam
                      repudiandae, dolores tempore esse vero aliquid illum neque
                      voluptatem.
                      <br />
                      <br />
                      Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                      Corrupti, aliquid illo? Quia dolore obcaecati incidunt
                      perferendis minus error repudiandae iure perspiciatis
                      maxime assumenda? Sit dicta, odit sunt maiores incidunt
                      culpa. Lorem ipsum dolor sit amet consectetur, adipisicing
                      elit. Assumenda voluptate quisquam quis officiis.
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <TabBox />
          <TestimonialSlider />
          <FaqEvent />

          {/* Footer 2 */}
          <FooterTwo />
        </div>
      </Styles>
    );
  }
}

export default Mission;
